<template>
  <form @submit.prevent="report()">
    <cytomine-modal :title="title" :active="active" @close="close()">
      <p class="field">{{ $t('report-message-explanation')}}</p>
      <b-field :label="$t('report-message-field')" :type="{ 'is-danger': errors.has('message') }" :message="errors.first('message')">
        <b-input v-model="message" name="message" v-validate="'required'" type="textarea" />
      </b-field>
      <br>
      <b-field>
        <b-checkbox v-model="discloseEmail" name="discloseEmail">
          {{ $t('checkbox-accept-report-recontact') }}
        </b-checkbox>
      </b-field>

      <template #footer>
        <button class="button" type="button" @click="close()">
          {{ $t("button-cancel") }}
        </button>
        <button class="button is-link" :disabled="errors.any()">
          {{ $t("button-send") }}
        </button>
      </template>
    </cytomine-modal>
  </form>
</template>

<script>
import { Cytomine } from 'cytomine-client';
import CytomineModal from '@/components/utils/CytomineModal';

export default {
  name: 'report-modal',
  extends: CytomineModal,
  props: {
    title: String,
    projectId: Number
  },
  components: { CytomineModal },
  $_veeValidate: { validator: 'new' },
  data() {
    return {
      message: '',
      discloseEmail: false
    };
  },
  methods: {
    async report() {
      try {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
          return;
        }

        const payload = {
          message: this.message,
          url: window.location.href,
          discloseEmail: this.discloseEmail
        };
        await Cytomine.instance.api.post(`project/${this.projectId}/report.json`, payload);

        this.$emit('update:active', false);
        this.$notify({
          type: 'success',
          title: this.$t('notif-success-report')
        });
      } catch (error) {
        console.error(error);
        this.$notify({
          type: 'error',
          title: this.$t('notif-error-report')
        });
      }
    }
  }
};
</script>

<style scoped>
::v-deep input[type="text"] {
  width: 26em;
}
</style>
